import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useSearch } from './AdminSearchContext';

const AdminMain = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const { searchTerm, setSearchTerm } = useSearch();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate('/Login');
      } else {
        setUser(user);
      }
    };

    const fetchUser = async () => {
      const { data: { user }, error } = await supabase.auth.getUser();

      if (user) {
        let name = "";
        if (user.user_metadata && user.user_metadata.full_name) {
          name = user.user_metadata.full_name;
        } else if (user.email) {
          name = user.email;
        }

        if (name) {
          // Si c'est une adresse e-mail, extraire la partie avant l'arobase
          if (name.includes('@')) {
            name = name.split('@')[0];
          }
          // Nettoyer les caractères spéciaux et capitaliser chaque mot
          name = name.replace(/[._-]/g, ' ')
                     .replace(/\b\w/g, c => c.toUpperCase())
                     .trim();
          
          // Mapper spécifiquement "President" vers "Président Numidya"
          if (name.toLowerCase() === 'president') {
            name = 'Président Numidya';
          }
          setFullName(name);
        }
      }
    };
    getUser();
    fetchUser();

    const handleToggle = () => {
      const body = document.querySelector('body');
      if (body.classList.contains('sidebar-icon-only')) {
        setSidebarCollapsed(true);
      } else {
        setSidebarCollapsed(false);
      }
    };

    const toggleBtn = document.querySelector('[data-toggle="minimize"]');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', handleToggle);
    }

    return () => {
      if (toggleBtn) {
        toggleBtn.removeEventListener('click', handleToggle);
      }
    };
  }, [navigate]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/Login');
  };

  const toggleSidebar = () => {
    const body = document.querySelector('body');
    body.classList.toggle('sidebar-icon-only');
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  if (!user) return null;

  return (
    <div className={`admin-dashboard-wrapper ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="container-scroller">
        <nav className="sidebar sidebar-offcanvas" id="sidebar">
          <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
            <Link className="sidebar-brand brand-logo" to="/Commandes">
              <img src="/assets/images/logoNumidya.png" alt="logo" />
            </Link>
            <Link className="sidebar-brand brand-logo-mini" to="/Commandes">
              <img src="/assets/images/logoNumidyaCompress.png" alt="logo" />
            </Link>
          </div>
          <ul className="nav" style={{ marginTop: 50, paddingTop: 50 }}>
            <li className="nav-item profile">
              <div className="profile-desc">
                <div className="profile-pic">
                  <div className="count-indicator">
                    <img className="img-xs rounded-circle" src="/assets/images/profilePicture.png" alt="profile" />
                    <span className="count bg-success"></span>
                  </div>
                  <div className="profile-name">
                    <h5 className="mb-0 font-weight-normal">{fullName || "Utilisateur"}</h5>
                    <span>Président</span>
                  </div>
                </div>
                <a href="#" id="profile-dropdown" data-toggle="dropdown">
                  <i className="mdi mdi-dots-vertical"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right sidebar-dropdown preview-list" aria-labelledby="profile-dropdown">
                  <a href="" className="dropdown-item preview-item" onClick={handleLogout}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-logout text-danger"></i> 
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small">Déconnexion</p>
                    </div>
                  </a>
                </div>
              </div>
            </li>
            <li className="nav-item nav-category">
              <span className="nav-link">Navigation</span>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/Commandes">
                <span className="menu-icon">
                  <i className="mdi mdi-cart-outline"></i>
                </span>
                <span className="menu-title">Mes commandes</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/AjouterProduit">
                <span className="menu-icon">
                  <i className="mdi mdi-package-variant"></i>
                </span>
                <span className="menu-title">Ajouter un produit</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/AjouterImage">
                <span className="menu-icon">
                  <i className="mdi mdi-image-plus"></i>
                </span>
                <span className="menu-title">Ajouter une image</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/AjouterEvenement">
                <span className="menu-icon">
                  <i className="mdi mdi-calendar-plus"></i>
                </span>
                <span className="menu-title">Ajouter un événement</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <a className="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
                <span className="menu-icon">
                  <i className="mdi mdi-silverware-fork-knife"></i>
                </span>
                <span className="menu-title">Restaurant   &nbsp;&nbsp;<i className="bi bi-chevron-down"></i></span>
              </a>
              <div className="collapse" id="ui-basic">
                <ul className="nav flex-column sub-menu"style={{ paddingLeft: '20px' }}>
                  <li className="nav-item">
                    <Link className="nav-link" to="/AjouterPlat">
                      <span className="menu-icon">
                        <i className="mdi mdi-food"></i>
                      </span>
                      <span className="menu-title">Ajouter un plat</span>
                    </Link>
                  </li>
                  
                  <li className="nav-item">
                    <Link className="nav-link" to="/ReservationRestaurant">
                      <span className="menu-icon">
                        <i className="mdi mdi-book-account"></i>
                      </span>
                      <span className="menu-title">Mes réservations</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/Newsletter">
                <span className="menu-icon">
                  <i className="mdi mdi-email-newsletter"></i>
                </span>
                <span className="menu-title">Newsletter</span>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="container-fluid page-body-wrapper">
          <nav className="navbar p-0 fixed-top d-flex flex-row">
            <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
              <Link className="navbar-brand brand-logo-mini" to="/Commandes">
                <img src="/assets/images/logoNumidyaCompress.png" alt="logo" />
              </Link>
            </div>

            <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
              <button 
                className="navbar-toggler navbar-toggler align-self-center d-none d-lg-block" 
                type="button" 
                onClick={toggleSidebar}
              >
                <span className="mdi mdi-menu"></span>
              </button>
              
              <ul className="navbar-nav w-100">
                <li className="nav-item w-100">
                  <form className="nav-link mt-2 mt-md-0 d-none d-lg-flex search">
                    <input 
                      type="text" 
                      placeholder="Rechercher une commande..." 
                      value={searchTerm}
                      onChange={handleSearch}
                      className="form-control search-input"
                    />
                  </form>
                </li>
              </ul>
              
              <ul className="navbar-nav navbar-nav-right">
                <li className="nav-item dropdown d-none d-lg-block">
                  <a 
                    href="https://terroir.numidya.pro/" 
                    className="nav-link btn btn-success create-new-button"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-arrow-right"></i> Terroir Numidya
                  </a>
                </li>
                <li className="nav-item dropdown d-none d-lg-block">
                  <a 
                    href="https://domaine.numidya.pro/" 
                    className="nav-link btn btn-success create-new-button"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-arrow-right"></i> Domaine Numidya
                  </a>
                </li>
              </ul>
              
              <ul className="navbar-nav navbar-nav-right">            
                <li className="nav-item nav-settings d-none d-lg-block">
                  <a className="nav-link" href="https://mail.google.com/mail/u/0/#inbox" target="_blank" rel="noopener noreferrer">
                   <i className="mdi mdi-email-outline"></i>
                  </a>
                </li>
              </ul>
              <button onClick={toggleMobileMenu} className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
                <span className="mdi mdi-format-line-spacing"></span>
              </button>
            </div>
          </nav>

          {mobileMenuOpen && ( 
            <div className="mobile-menu-overlay d-lg-none">
              <div 
                className="mobile-menu-backdrop"
                onClick={toggleMobileMenu}
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  zIndex: 999
                }}
              ></div>
              <div 
                className="mobile-sidebar"
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  height: '100%',
                  zIndex: 1000,
                  overflowY: 'auto',
                  boxShadow: '2px 0 10px rgba(0,0,0,0.1)'
                }}
              >
                <div className="sidebar-brand-wrapper d-flex align-items-center justify-content-center" style={{ padding: '20px', borderBottom: '1px solid #333', backgroundColor: '#1f1f1f' }}>
                  <Link className="sidebar-brand brand-logo" to="/Commandes" onClick={toggleMobileMenu}>
                    <img src="/assets/images/logoNumidya.png" alt="logo" style={{ maxWidth: '150px' }} />
                  </Link>
                  <button 
                    onClick={toggleMobileMenu}
                    style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      border: 'none',
                      background: 'none',
                      fontSize: '24px',
                      cursor: 'pointer',
                      color: '#fff'
                    }}
                  >
                    ×
                  </button>
                </div>

                {/* Profile section */}
                 <div className={`admin-dashboard-wrapper ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="container-scroller">
        <nav className="sidebar " id="sidebar">
          <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
            <Link className="sidebar-brand brand-logo" to="/Commandes">
              <img src="/assets/images/logoNumidya.png" alt="logo" />
            </Link>
            <Link className="sidebar-brand brand-logo-mini" to="/Commandes">
              <img src="/assets/images/logoNumidyaCompress.png" alt="logo" />
            </Link>
          </div>
          <ul className="nav" style={{ padding: '20px 0' }}>
            <li className="nav-item profile">
              <div className="profile-desc">
                <div className="profile-pic">
                  <div className="count-indicator">
                    <img className="img-xs rounded-circle" src="/assets/images/profilePicture.png" alt="profile" />
                    <span className="count bg-success"></span>
                  </div>
                  <div className="profile-name">
                    <h5 className="mb-0 font-weight-normal">{fullName || "Utilisateur"}</h5>
                    <span>Président</span>
                  </div>
                </div>
                <a href="#" id="profile-dropdown" data-toggle="dropdown">
                  <i className="mdi mdi-dots-vertical"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right sidebar-dropdown preview-list" aria-labelledby="profile-dropdown">
                  <a href="" className="dropdown-item preview-item" onClick={handleLogout}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-logout text-danger"></i> 
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small">Déconnexion</p>
                    </div>
                  </a>
                </div>
              </div>
            </li>
            <li className="nav-item nav-category">
              <span className="nav-link">Navigation</span>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/Commandes" onClick={toggleMobileMenu}>
                <span className="menu-icon">
                  <i className="mdi mdi-cart-outline"></i>
                </span>
                <span className="menu-title">Mes commandes</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/AjouterProduit" onClick={toggleMobileMenu}>
                <span className="menu-icon">
                  <i className="mdi mdi-package-variant"></i>
                </span>
                <span className="menu-title">Ajouter un produit</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/AjouterImage" onClick={toggleMobileMenu}>
                <span className="menu-icon">
                  <i className="mdi mdi-image-plus"></i>
                </span>
                <span className="menu-title">Ajouter une image</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/AjouterEvenement" onClick={toggleMobileMenu}>
                <span className="menu-icon">
                  <i className="mdi mdi-calendar-plus"></i>
                </span>
                <span className="menu-title">Ajouter un événement</span>
              </Link>
            </li>
            
            <li className="nav-item menu-items">
              <a className="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
                <span className="menu-icon">
                  <i className="mdi mdi-silverware-fork-knife"></i>
                </span>
                <span className="menu-title">Restaurant   &nbsp;&nbsp;<i className="bi bi-chevron-down"></i></span>
              </a>
              <div className="collapse" id="ui-basic">
                <ul className="nav flex-column sub-menu"style={{ paddingLeft: '20px' }}>
                  <li className="nav-item">
                    <Link className="nav-link" to="/AjouterPlat" onClick={toggleMobileMenu}>
                      <span className="menu-icon">
                        <i className="mdi mdi-food"></i>
                      </span>
                      <span className="menu-title">Ajouter un plat</span>
                    </Link>
                  </li>
                  
                  <li className="nav-item">
                    <Link className="nav-link" to="/ReservationRestaurant" onClick={toggleMobileMenu}>
                      <span className="menu-icon">
                        <i className="mdi mdi-book-account"></i>
                      </span>
                      <span className="menu-title">Mes réservations</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item menu-items">
              <Link className="nav-link" to="/Newsletter" onClick={toggleMobileMenu}>
                <span className="menu-icon">
                  <i className="mdi mdi-email-newsletter"></i>
                </span>
                <span className="menu-title">Newsletter</span>
              </Link>
            </li>
            <li style={{ marginTop: '30px', padding: '15px', borderTop: '1px solid #eee' }}>
            <Link 
              className="book-a-table-btn-mobile btn-success"
              to="https://terroir.numidya.pro/"
              target="_blank"
              rel="noopener noreferrer"
             
              style={{
                display: 'block',
                textAlign: 'center',
                padding: '9px 17px',
                marginTop: '10px',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              <i className="bi bi-arrow-right"></i> &nbsp; Terroir Numidya
            </Link>
          </li>
           <li style={{ marginTop: '-10px', padding: '15px' }}>
            <Link 
              className="book-a-table-btn-mobile btn-success"
              to="https://domaine.numidya.pro/" 
              target="_blank"
              rel="noopener noreferrer"
             
              style={{
                display: 'block',
                textAlign: 'center',
                padding: '9px 17px',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              <i className="bi bi-arrow-right"></i> &nbsp; Domaine Numidya
            </Link>
          </li>
          </ul>
        </nav>
        </div> 
        </div>  
              </div>
            </div>
          )}
          
          <div className="main-panel">
            <main style={{ flexGrow: 1,  paddingBottom: "10px" }}>
              {children || <Outlet />}
            </main>
            <footer className="footer">
              <div className="d-sm-flex justify-content-center justify-content-sm-between">
                <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">
                  Copyright © Numidya 2025. All Rights Reserved
                </span>
                <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
                  Created by <a href="" target="_blank" rel="noopener noreferrer">Amine Makni</a>
                </span>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMain;